import { render } from "./App.vue?vue&type=template&id=7ffb483e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7ffb483e&lang=css"
script.render = render

export default script